<template>
    <section class="section" v-if="design==='homepage'">
        <div class="container">
            <div class="route-planner-content">
                <div class="section-header">
                    <h2 class="text-center" v-html="$t('directions.routePlannerHomepageTitle')"></h2>
                    <p class="text-center" v-html="$t('directions.routePlanner_homepage_description')"></p>
                </div>
                <div class="planner-search-container">
                    <div v-if="status.loading" class="loading-overlay"></div>
                    <div v-if="status.loading" class="loading-alert">
                        <i class="mdi mdi-refresh mdi-spin"></i>
                        <span v-html="$t('directions.alert_loading')"></span>
                    </div>
                    <div class="search-inputs">
                        <div class="search-items">
                            <div class="input-group">
                                <label :for="`directions-origin-${mapId}`" v-html="$t('directions.origin')"></label>
                                <input
                                    type="text"
                                    name="directions_origin"
                                    ref="origin"
                                    :id="`directions-origin-${mapId}`"
                                    required="required"
                                    v-model="route.origin"
                                    :placeholder="$t('directions.originPlaceholder')"
                                    :class="{'is-invalid': formErrors.origin}"
                                />
                                <div class="invalid-feedback">
                                    <span class="d-block" v-for="error in formErrors.origin" :key="error">
                                        {{ error }}
                                    </span>
                                </div>
                            </div>
                            <div class="input-group">
                                <label :for="`directions-destination-${mapId}`"
                                       v-html="$t('directions.destination')"></label>
                                <input
                                    type="text"
                                    name="directions_destination"
                                    ref="destination"
                                    :id="`directions-destination-${mapId}`"
                                    required="required"
                                    v-model="route.destination"
                                    :placeholder="$t('directions.destinationPlaceholder')"
                                    :class="{'is-invalid': formErrors.destination}"
                                />
                                <div class="invalid-feedback">
                                    <span class="d-block" v-for="error in formErrors.destination" :key="error">
                                        {{ error }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <p class="go-to-route-planner">
                            <span id="info-icon" aria-hidden="true">i</span>
                            <a :href="mapRoute" v-if="isMobile" v-html="$t('directions.gotoplanner_mobile')"></a>
                            <a :href="mapRoute" v-else v-html="$t('directions.gotoplanner')"></a>
                        </p>
                    </div>
                    <div class="btn-container">
                        <button
                            type="button"
                            name="directions_search"
                            class="btn btn-primary font-weight-normal w-12ch search-button"
                            :disabled="status.loading"
                            @click.prevent="load"
                        >
                            {{ $t('directions.search') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: none !important;"
             :class="{
                            'mb-mobile-0': !status.ready,
                         }"
             v-show="!status.initial || status.ready"
        >
            <div style="display: none" :id="mapId" class="bg-light" ref="map"></div>
        </div>
    </section>

    <section
        class="directions section bg-light section-offset-small"
        :class="{ 'mt-0': design === 'configurator' }"
        v-else-if="design!=='homepage'"
    >
        <div class="route-planner-page">
            <div class="container p-4 feature-form selector mb-4 mb-mobile-0">
                <div class="row">
                    <div class="col-md-12 mb-mobile-1 px-0 mobile-spacing-x text-align-left">
                        <div class="input-desktop">
                            <div
                                class="mobile-spacing-y hide-mobile desktop-info-i-top"
                                @mouseover="showInfoBox = true"
                                @mouseleave="showInfoBox = false"
                            >
                                <span class="mdi mdi-information-outline mdi-36px icon-primary-color"></span>
                            </div>
                            <div class="form-desktop mobile-spacing-y">
                                <label class="text-xl label-font mobile-top margin-top-labels"
                                       :for="`directions-origin-${mapId}`"
                                       v-html="$t('directions.origin')"></label>
                                <div
                                    class="show-mobile"
                                    @click="showInfoBox = !showInfoBox"
                                >
                                    <span class="mdi mdi-information-outline mdi-36px icon-primary-color"></span>
                                </div>
                                <input
                                    type="text"
                                    name="directions_origin"
                                    ref="origin"
                                    :id="`directions-origin-${mapId}`"
                                    required="required"
                                    class="form-control bg-white overlap-input shadow-lg"
                                    v-model="route.origin"
                                    :placeholder="$t('directions.originPlaceholder')"
                                    :class="{'is-invalid': formErrors.origin}"
                                />
                                <div class="invalid-feedback">
                                    <span class="d-block" v-for="error in formErrors.origin" :key="error">
                                        {{ error }}
                                    </span>
                                </div>
                            </div>
                            <div class="form-desktop mobile-spacing-y">
                                <label
                                    class="text-xl label-font margin-top-labels"
                                    :for="`directions-destination-${mapId}`"
                                    v-html="$t('directions.destination')"></label>
                                <input
                                    type="text"
                                    name="directions_destination"
                                    ref="destination"
                                    :id="`directions-destination-${mapId}`"
                                    required="required"
                                    class="form-control bg-white overlap-input shadow-lg"
                                    v-model="route.destination"
                                    :placeholder="$t('directions.destinationPlaceholder')"
                                    :class="{'is-invalid': formErrors.destination}"
                                />
                                <div class="invalid-feedback">
                                    <span class="d-block" v-for="error in formErrors.destination" :key="error">
                                        {{ error }}
                                    </span>
                                </div>
                            </div>
                            <div class="mb-0 form-desktop">
                                <div class="custom-control custom-checkbox my-mobile-1">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input checkbox"
                                        :id="`route-back-${mapId}`"
                                        v-model="route.includeBack"
                                        :value="true"
                                    />
                                    <label
                                        class="custom-control-label margin-top-desktop"
                                        :for="`route-back-${mapId}`"
                                        v-html="$t('directions.route_back')"
                                    ></label>
                                </div>
                            </div>
                            <div>
                                <label class="d-mobile-none mb-0" style="display: block">&nbsp;</label>
                                <button
                                    type="button"
                                    name="directions_search"
                                    class="btn btn-primary rounded w-100 button-desktop shadow-lg"
                                    :disabled="status.loading"
                                    @click.prevent="load"
                                >
                                    {{ $t('directions.search') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mobile-spacing-x" :class="{'map-shift': !formErrors.origin && !formErrors.destination}">
                    <div class="col-md-12 bg-white rounded shadow-lg p-0">
                        <div v-if="status.loading" class="loading-overlay"></div>
                        <div v-if="status.loading" class="mb-0 loading-alert text-white" role="alert">
                            <i class="mdi mdi-refresh mdi-spin"></i>
                            <span v-html="$t('directions.alert_loading')"></span>
                        </div>
                        <div v-if="showInfoBox"
                             class="info-overlay p-4 row align-items-center bg-white rounded px-0 border-primary">
                            <h4 class="mb-0 mb-mobile mobile-text-center" v-html="$t('directions.info_title')"></h4>
                            <span
                                class="text-quote mobile-text-center"
                                v-html="$t('directions.info_text')"
                            ></span>
                        </div>
                        <div class="google-map mb-0 p-1 w-100 map-height"
                             :class="{
                            'mb-mobile-0': !status.ready,
                         }"
                             v-show="!status.initial || status.ready"
                        >
                            <div :id="mapId" class="bg-light rounded" ref="map"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        mapId: {
            type: String,
            required: true,
        },
        askForUserLocation: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
        initialMapLat: {
            type: Number,
            required: false,
            default() {
                return 47.6928623;
            },
        },
        initialMapLng: {
            type: Number,
            required: false,
            default() {
                return 12.2247775;
            },
        },
        defaultZoom: {
            type: Number,
            required: false,
            default() {
                return 13;
            },
        },
        design: {
            type: String,
            required: false,
        },
        mapRoute: {
            type: String,
            require: false,
        },
    },
    data() {
        return {
            formErrors: {},
            showInfoBox: false,
            status: {
                initial: true,
                ready: false,
                loading: false,
                failed: false,
                hasRouteBack: false,
            },
            callbackId: null,
            autocomplete: {
                origin: null,
                destination: null,
            },
            route: {
                origin: '',
                destination: '',
                includeBack: false,
            },
            map: null,
            directions: {
                routeKey: 0,
                routes: [],
                markers: [],
                polyLines: [],
            },
            active: {
                id: null,
                route: null,
            },
            activeBack: {
                id: null,
                route: null,
            },
            requirements: {
                isVignetteRequired: false,
                isRouteTollRequired: false,
                hasInfo: false,
                products: {
                    vignettes: [],
                    routeTolls: [],
                    infos: {},
                },
                systems: {},
            },
            isMobile: this.isMobileDevice(),
        };
    },

    watch: {
        /**
         * Watches the status data to emit a status-update if necessary.
         */
        status: {
            deep: true,
            handler() {
                this.$emit('status-update', this.status);
            },
        },
    },

    computed: {
        /**
         * @returns {{strictBounds: boolean, bounds: {east: number, south: number, north: number, west: number}, fields: string[]}}
         */
        autocompleteOptions() {
            return {
                bounds: {
                    north: 90,
                    south: -90,
                    east: 180,
                    west: -180,
                },
                fields: ['address_components', 'geometry', 'icon', 'name'],
                strictBounds: false,
            };
        },

        /**
         * @returns {{mapTypeId: *, mapTypeControl: boolean, scaleControl: boolean, center: {lng: number, lat: number}, streetViewControl: boolean, fullscreenControl: boolean, zoom: number, controlSize: number}}
         */
        mapOptions() {
            let lat = this.initialMapLat,
                lng = this.initialMapLng,
                zoom = this.defaultZoom;

            try {
                if (!this.askForUserLocation) {
                    throw new Error('The user location request is disabled.');
                }

                let storage =
                    window.sessionStorage.getItem('tollCalculatorPos');
                storage = storage !== null ? JSON.parse(storage) : null;

                if (storage === null) {
                    throw new Error('Missing or invalid position cache.');
                }

                lat = storage.lat;
                lng = storage.lng;
                zoom = storage.zoom;
            } catch (error) {
                window.sessionStorage.removeItem('tollCalculatorPos');
            }

            return {
                center: {
                    lat,
                    lng,
                },
                zoom,
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                scaleControl: true,
                controlSize: 32,
            };
        },
    },

    methods: {
        /**
         * Check if device is a mobile or desktop.
         */
        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        /**
         * Handle the initialization of the map view.
         *
         * @returns {void}
         */
        initialize() {
            this.autocomplete.origin = new window.google.maps.places.Autocomplete(
                this.$refs.origin,
                this.autocompleteOptions
            );
            this.autocomplete.origin.addListener('place_changed', () => {
                this.route.origin = this.$refs.origin.value;
            });

            this.autocomplete.destination = new window.google.maps.places.Autocomplete(
                this.$refs.destination,
                this.autocompleteOptions
            );
            this.autocomplete.destination.addListener('place_changed', () => {
                this.route.destination = this.$refs.destination.value;
            });

            this.map = new window.google.maps.Map(
                this.$refs.map,
                this.mapOptions
            );
            this.status.initial = false;
        },

        /**
         * Handle the loading of the route plan.
         *
         * @returns {void}
         */
        load() {
            if (this.status.loading) {
                return;
            }

            this.$set(this, 'formErrors', {});

            // Before we send the real request, we have to make sure that the necessary information was entered.
            if (
                typeof this.route.origin !== 'string' ||
                this.route.origin.trim().length === 0
            ) {
                this.formErrors.origin ??= [];
                this.formErrors.origin.push(
                    this.$t('configurator.validation_value_needed', {
                        field: this.$t('directions.origin').replace(':', ''),
                    })
                );
                return;
            } else if (
                typeof this.route.destination !== 'string' ||
                this.route.destination.trim().length === 0
            ) {
                this.formErrors.destination ??= [];
                this.formErrors.destination.push(
                    this.$t('configurator.validation_value_needed', {
                        field: this.$t('directions.destination').replace(':', ''),
                    })
                );
                return;
            }

            this.status.failed = false;
            this.status.loading = true;
            this.status.hasRouteBack = this.status.ready = false;
            this.active.id = this.active.route = null;
            this.activeBack.id = this.activeBack.route = null;
            axios
                .get(`/${this.$language}/backend/map`, {
                    params: {
                        origin: this.route.origin,
                        destination: this.route.destination,
                        back: this.route.includeBack ? 'yes' : 'no',
                    },
                })
                .then((response) => {
                    if (!response.data.success) {
                        this.status.failed = true;
                        this.status.loading = false;

                        return;
                    }

                    // Handle the reset of the map before we render the new content to it.
                    this.resetMap();
                    this.directions.routes = response.data.routes.map((route, index) => {
                        route.id = index;

                        return route;
                    });
                    this.requirements.systems = response.data.systems;
                    this.directions.routeKey++;
                    this.$emit('routes-updated', this.directions.routes);

                    this.drawMap();

                    // Unset the loading state.
                    this.status.loading = false;
                    this.status.ready = true;
                    this.$nextTick(() => {
                        if (this.design !== 'homepage') {
                            if (!this.$refs.map || !this.$refs.map.scrollIntoView) {
                                return;
                            }
                            this.$refs.map.scrollIntoView();
                        } else {
                            this.$emit('scroll-to-feature-form');
                        }
                    });
                })
                .catch(() => {
                    this.status.failed = true;
                    this.status.loading = false;
                });
        },

        /**
         * Handle the reset of the map, in this specific case the routes and markers will be removed.
         *
         * @returns {this}
         */
        resetMap() {
            for (const index in this.directions.routes) {
                this.directions.polyLines[index].setMap(null);
            }

            for (const index in this.directions.markers) {
                this.directions.markers[index].setMap(null);
            }

            this.directions.routes = [];
            this.directions.markers = [];
            this.directions.polyLines = [];
            this.$emit('routes-updated', this.directions.routes);

            return this;
        },

        /**
         * Handle the rendering of the map.
         *
         * @returns {this}
         */
        drawMap() {
            for (const routeId in this.directions.routes) {
                const route = this.directions.routes[routeId];

                if (
                    typeof route.draw !== 'object' ||
                    !(route.draw instanceof Array)
                ) {
                    continue;
                }

                this.directions.polyLines[routeId] =
                    new window.google.maps.Polyline({
                        path: route.draw,
                        geodesic: true,
                        strokeColor: '#777',
                        strokeOpacity: 0.33,
                        strokeWeight: 7,
                        zIndex: 1,
                        route: routeId,
                    });
                window.google.maps.event.addListener(
                    this.directions.polyLines[routeId],
                    'click',
                    () => {
                        this.selectRoute(route, routeId);
                    }
                );
                this.directions.polyLines[routeId].setMap(this.map);

                const startMarkerId = `start_${routeId}`,
                    endMarkerId = `end_${routeId}`;
                if (
                    typeof route.start.coordinates === 'object' &&
                    route.start.coordinates !== null
                ) {
                    this.directions.markers[startMarkerId] =
                        new window.google.maps.Marker({
                            position: route.start.coordinates,
                            map: this.map,
                            title: route.start.address,
                        });
                }

                if (
                    typeof route.end.coordinates === 'object' &&
                    route.end.coordinates !== null
                ) {
                    this.directions.markers[endMarkerId] =
                        new window.google.maps.Marker({
                            position: route.end.coordinates,
                            map: this.map,
                            title: route.end.address,
                        });
                }
            }

            if (this.active.id === null && this.directions.routes.length > 0) {
                for (const activeRouteId in this.directions.routes) {
                    if (
                        typeof this.directions.routes[activeRouteId].back ===
                        'boolean' &&
                        this.directions.routes[activeRouteId].back
                    ) {
                        continue;
                    }

                    this.selectRoute(
                        this.directions.routes[activeRouteId],
                        activeRouteId
                    );
                    break;
                }
            }

            if (
                this.activeBack.id === null &&
                this.directions.routes.length > 0
            ) {
                for (const activeBackRouteId in this.directions.routes) {
                    if (
                        typeof this.directions.routes[activeBackRouteId]
                            .back !== 'boolean' ||
                        !this.directions.routes[activeBackRouteId].back
                    ) {
                        continue;
                    }

                    this.selectRoute(
                        this.directions.routes[activeBackRouteId],
                        activeBackRouteId
                    );
                    this.status.hasRouteBack = true;
                    break;
                }
            }

            return this;
        },

        /**
         * @param {Object} position
         * @param {Number|undefined} zoom
         *
         * @returns {void}
         */
        updateCenter(position, zoom) {
            if (this.map === null) {
                return;
            }

            zoom =
                typeof zoom === 'number' && !isNaN(zoom)
                    ? zoom
                    : this.mapOptions.zoom;
            this.map.setCenter(
                new window.google.maps.LatLng(position.lat, position.lng)
            );
            this.map.setZoom(zoom);
        },

        /**
         * @param {Number} routeId
         *
         * @returns {void}
         */
        highlightActivePolyLines(routeId) {
            if (
                this.directions.polyLines.length === 0 ||
                typeof this.directions.polyLines[routeId] === 'undefined'
            ) {
                return;
            }

            for (const id in this.directions.polyLines) {
                if (id === routeId) {
                    continue;
                }

                this.directions.polyLines[id].setOptions({
                    strokeColor: '#777',
                    zIndex: 0.5,
                });
            }

            this.directions.polyLines[routeId].setOptions({
                strokeColor: '#2f55d4',
                zIndex: 2,
            });
        },

        /**
         * Handle the selection of the provided route.
         *
         * @param {Object} route
         * @param {Number} routeId
         *
         * @returns {void}
         */
        selectRoute(route, routeId) {
            routeId = parseInt(routeId.toString());
            const isBack = typeof route.back === 'boolean' && route.back;

            if (isBack) {
                this.activeBack.id = routeId;
                this.activeBack.route = route;
            } else {
                this.active.id = routeId;
                this.active.route = route;
            }

            const bounds = new window.google.maps.LatLngBounds();
            const startMarkerId = `start_${routeId}`,
                endMarkerId = `end_${routeId}`;

            if (
                typeof this.directions.markers[startMarkerId] === 'object' &&
                this.directions.markers[startMarkerId] !== null
            ) {
                bounds.extend(
                    new window.google.maps.LatLng(
                        this.directions.markers[startMarkerId].position.lat(),
                        this.directions.markers[startMarkerId].position.lng()
                    )
                );
            }
            if (
                typeof this.directions.markers[endMarkerId] === 'object' &&
                this.directions.markers[endMarkerId] !== null
            ) {
                bounds.extend(
                    new window.google.maps.LatLng(
                        this.directions.markers[endMarkerId].position.lat(),
                        this.directions.markers[endMarkerId].position.lng()
                    )
                );
            }

            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
            this.highlightActivePolyLines(routeId);
            this.showNecessaryProducts(isBack);
            this.$emit('route-selected', {
                isBack,
                route,
            });
        },

        /**
         * Handle the display of the possible necessary products.
         *
         * @param {bool} isBack
         *
         * @returns {void}
         */
        showNecessaryProducts(isBack) {
            // In the first step, we have to figure out if the towards or back route have to be checked.
            const route = (isBack ? this.activeBack : this.active).route;
            const prevRoute = (isBack ? this.active : this.activeBack).route;
            const vignettes = [];
            const vignetteSystemIds = [];
            const routeTolls = [];
            const routeTollNames = [];

            if (typeof route.tollProductRequirements === 'undefined') {
                route.tollProductRequirements = {
                    vignettes: {},
                    routeTolls: {},
                    infos: {},
                };
            }

            // Merge previous results from the previous selected route
            let vignetteObj = route.tollProductRequirements.vignettes;
            let routeTollObj = route.tollProductRequirements.routeTolls;
            let infos = route.tollProductRequirements.infos;
            if (prevRoute !== null) {
                vignetteObj = { ...vignetteObj, ...prevRoute.tollProductRequirements.vignettes };
                routeTollObj = { ...routeTollObj, ...prevRoute.tollProductRequirements.routeTolls };
                infos = { ...infos, ...prevRoute.tollProductRequirements.infos };
            }

            // Because the vignettes normally are valid for any vignette routes (except the route toll requirements),
            // we have to add each vignette only once. Which means the same product with a different validity range,
            // can be ignored.
            for (const internalId in vignetteObj) {
                const product = vignetteObj[internalId];

                if (vignetteSystemIds.indexOf(product.system_id) !== -1) {
                    continue;
                }

                vignettes.push(this.extendProduct(product));
                vignetteSystemIds.push(product.system_id);
            }

            // Like mentioned before, the route tolls have to be handled differently. Which means we have to compare the
            // names, because if a name is duplicated we are fine to handle it once.
            for (const internalId in routeTollObj) {
                const product = routeTollObj[internalId];
                const name =
                    product.names['en'] ||
                    product.names['de'] ||
                    JSON.stringify(product.names);

                if (routeTollNames.indexOf(name) !== -1) {
                    continue;
                }

                routeTolls.push(this.extendProduct(product));
                routeTollNames.push(name);
            }

            this.requirements.isVignetteRequired = vignettes.length > 0;
            this.requirements.isRouteTollRequired = routeTolls.length > 0;
            this.requirements.hasInfo = Object.keys(infos).length > 0;
            this.requirements.products.vignettes = vignettes;
            this.requirements.products.routeTolls = routeTolls;
            this.requirements.products.infos = infos;
            this.$emit('requirements-updated', this.requirements, this.design);
        },

        /**
         * Handles the extension of the products, to provide additional helpful properties or methods.
         *
         * @param {Object} product
         *
         * @returns {*}
         */
        extendProduct(product) {
            product.isConfigured = false;

            return product;
        },
    },

    /**
     * @returns {void}
     */
    beforeMount() {
        this.callbackId = `tollCalculator_${this._uid}`;
        window[this.callbackId] = () => {
            // If the Google library is not available, then the load seems to be failed.
            if (typeof window.google !== 'object') {
                this.status.failed = true;

                return;
            }

            if (this.askForUserLocation && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const data = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        zoom: this.defaultZoom,
                    };
                    window.sessionStorage.setItem(
                        'tollCalculatorPos',
                        JSON.stringify(data)
                    );
                    this.updateCenter(data, data.zoom);
                });
            }

            this.status.isInitialize = false;
            this.$nextTick(this.initialize);
        };
    },

    /**
     * @returns {void}
     */
    mounted() {
        if (typeof window.google !== 'object') {
            this.status.failed = true;

            return;
        }

        window[this.callbackId]();
    },
};
</script>
